export default __webpack_public_path__ + "static/media/img3.694f9da0.jpg";